import React, { FC, RefObject, useCallback, useEffect, useRef } from 'react'
import { useToasts } from 'react-toast-notifications'

import { TMediaCallbacks } from '../../pages/CreatePost'
import PostMediaPlaceholder, { MEDIA_TYPE_TO_UPLOAD } from '../PostMediaPlaceholder'
import { TOAST_MESSAGE } from '../UI/ToastNotification/ToastNotification'

import { TExtendedPostAttachment, TRemoveAttachmentPayload } from '../../store/managePost/newTypes'

import './UploadVideo.scss'
import VideoPreview from '../UI/VideoPreview'
import TrashIcon from '../UI/Icons/Trash'

const MAX_FILE_SIZE = 2e8 // 200 MB

// TODO simplify and rename
interface UploadVideoProps {
  attachments: TExtendedPostAttachment[]
  addMediaToPost: (image: any) => void
  refMediaCallbaks: RefObject<TMediaCallbacks>
  restrictions: any
  removeMediaFromStore: (id: TRemoveAttachmentPayload) => void
  isEditable: boolean
}

const UploadVideo: FC<UploadVideoProps> = ({
  attachments,
  addMediaToPost,
  refMediaCallbaks,
  removeMediaFromStore,
  restrictions,
  isEditable
}) => {
  const refUploadVideo = useRef<HTMLInputElement>(null)
  const refVideoPlayer = useRef<HTMLVideoElement>(null)

  const { addToast } = useToasts()

  const openVideoDialog = useCallback(() => {
    return refUploadVideo.current?.click()
  }, [refUploadVideo])

  useEffect(() => {
    if (refUploadVideo.current && refMediaCallbaks.current) {
      refMediaCallbaks.current.addVideo = openVideoDialog
    }
  }, [refUploadVideo, openVideoDialog])

  const onInputChange = async (event: any) => {
    const files = refUploadVideo.current?.files
    const reader = new FileReader()
    reader.onload = (e) => {
      refVideoPlayer.current?.load()
      refVideoPlayer.current?.play()
    }

    if (files && files[0]) {
      const fileToUpload = files[0]
      if (fileToUpload.size < MAX_FILE_SIZE) {
        addMediaToPost({ file: files[0] })
        reader.readAsDataURL(files[0])
      } else {
        addToast(TOAST_MESSAGE.MAX_FILE_SIZE_OF_VIDEO, { appearance: 'error' })
        refUploadVideo.current!.value = ''
      }
    }
  }
  return (
    <div className='upload-video'>
      {!attachments.length && (
        <div className='upload-video__wrapper'>
          <PostMediaPlaceholder mediaType={MEDIA_TYPE_TO_UPLOAD.VIDEO} onClick={openVideoDialog} />
          <input
            className='upload-video__input'
            accept='video/*'
            ref={refUploadVideo}
            type='file'
            onChange={onInputChange}
          />
        </div>
      )}
      {attachments.map((attachment) => (
        <div
          className='upload-video__video-wrapper'
          key={`video-${attachment.object_data?.id}-${attachment.id}`}
        >
          <VideoPreview
            attachment={attachment}
            width={438}
            className='upload-video__video-wrapper__player'
          />
          {isEditable && (
            <div
              key={`post-video-${attachment.object_id}`}
              className='upload-video__video-wrapper__remove-item'
              onClick={() =>
                removeMediaFromStore({ id: attachment.id, temporaryId: attachment.temporaryId })
              }
            >
              <TrashIcon />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default UploadVideo
